<script setup>
import ProductGrid from '@/components/registry/ProductGrid.vue'
</script>
<template>
  <product-grid />
</template>
